import { render } from "./InventoryPriceLogs.vue?vue&type=template&id=29a1d4a3"
import script from "./InventoryPriceLogs.vue?vue&type=script&lang=js"
export * from "./InventoryPriceLogs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__